import { CommandsService } from '@weave/schema-gen-ts/dist/schemas/payments/commands/service/service.pb';
import { bindHTTP } from '@frontend/schema';

export const SchemaCommands1Service = bindHTTP(CommandsService);
export const serviceName = 'commands1' as const;
